import React from 'react';
import styled from 'styled-components';
import {CatalogItemCard} from '../../../common/ui/CatalogItemCard';
import {PriceWithFallback} from '../../../common/ui/PriceWithFallback';
import {Indicador} from '../../../ui';
import {useRestockedTrackedProducts} from '../../../product/application/useRestockedTrackedProducts';
import {AddRestockedToCartButton} from '../../../product/ui/AddRestockedToCartButton';
import {isSuccess} from '../../../common/domain/RemoteData.model';

const Container = styled.div`
    display: flex;
    gap: 1.5rem;
    flex-direction: column;
`;

const GridWrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
    box-sizing: border-box;
`;

const CardWrapper = styled.div`
    flex: 0 0 auto;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

/**
 * Sección destacada de la home con los productos pendientes que ya
 * tienen stock suficiente para la cantidad deseada.
 */
export const RestockedTrackedProducts = () => {
    const {trackedData, restocked, refresh, removeLocally} = useRestockedTrackedProducts();

    if (!isSuccess(trackedData) || restocked.length === 0) {
        return null;
    }

    return (
        <Container>
            <Indicador indicador="¡Ya hay stock de tus pendientes!" />
            <GridWrapper>
                {restocked.map((product) => (
                    <CardWrapper key={product.code}>
                        <CatalogItemCard data={{ catalogItem: product }}>
                            <CatalogItemCard.Price>
                                <PriceWithFallback data={{
                                    sellingPrice: product.price?.bestPrice,
                                    basePrice: product.price?.value
                                }}/>
                            </CatalogItemCard.Price>
                        </CatalogItemCard>
                        <AddRestockedToCartButton
                            product={product}
                            onAdded={removeLocally}
                            onFailed={refresh}
                        />
                    </CardWrapper>
                ))}
            </GridWrapper>
        </Container>
    );
};
